<template>
  <v-container tag="section" class="content detail">
    <v-row v-if="this.$auth.user().id">
      <v-col class="text-right">
        <v-btn :color="currentColor()" :to="{ name: 'frontend.my-family' }">
          {{ $t("my_family.menu_button") }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="mx-auto mt-0" color="white" max-width="100%">
          <v-progress-linear
            indeterminate
            rounded
            height="6"
            v-if="loading"
          ></v-progress-linear>
          <template v-else>
            <v-img
              class="white align-end"
              height="300px"
              :src="item.image || '/img/background.jpg'"
            >
            </v-img>
            <v-card-title v-if="$i18n.locale == 'de'">{{
              item.name
            }}</v-card-title>
            <v-card-title v-else>{{ item.name_it }}</v-card-title>

            <v-card-text class="mt-3">
              <template v-if="item.from">
                <div class="my-4">
                  <b>{{ $t("period") }} :</b> {{ item.from | formatDate }}
                  <span v-if="item.to">- {{ item.to | formatDate }}</span>
                </div>
              </template>
              <template v-if="item.location && item.location.name">
                <div class="my-4">
                  <b>{{ $t("Location") }}: </b>
                  <span v-if="$i18n.locale == 'de'">{{
                    item.location.name
                  }}</span
                  ><span v-else>{{ item.location.name_it }}</span>
                </div>
              </template>

              <template v-if="item.info">
                <div class="my-4">
                  <h4>{{ $t("info") }}</h4>
                  <div v-if="$i18n.locale == 'de'" v-html="item.info"></div>
                  <div v-else v-html="item.info_it"></div>
                </div>
              </template>

              <template v-if="item.program">
                <div class="my-4">
                  <h4>{{ $t("program") }}:</h4>
                  <v-btn small target="_blank" :href="item.program">{{
                    $t("download")
                  }}</v-btn>
                </div> </template
              ><span v-else>-</span>

              <template v-if="item.register_to">
                <div class="my-4">
                  <b v-if="item.register_to_phase2"
                    >{{ $t("registration_phase1") }}:</b
                  >
                  <b v-else>{{ $t("registration") }}:</b>
                  <div>
                    {{ item.register_from | formatDate }}
                    <span v-if="item.register_from_time">
                      {{ item.register_from_time | formatTime }}
                    </span>
                    <span v-if="item.register_to"
                      >- {{ item.register_to | formatDate }}</span
                    >
                    <span v-if="item.register_to_time">
                      {{ item.register_to_time | formatTime }}
                    </span>
                  </div>
                </div>
              </template>

              <template v-if="item.register_to_phase2">
                <div class="my-4">
                  <b>{{ $t("registration_phase2") }}:</b>
                  <div>
                    {{ item.register_from_phase2 | formatDate }}
                    <span v-if="item.register_from_time_phase2">
                      {{ item.register_from_time_phase2 | formatTime }}
                    </span>
                    <span v-if="item.register_to_phase2"
                      >- {{ item.register_to_phase2 | formatDate }}</span
                    >
                    <span v-if="item.register_to_time_phase2">
                      {{ item.register_to_time_phase2 | formatTime }}
                    </span>
                  </div>
                </div>
              </template>

              <template v-if="item.price">
                <div class="my-4">
                  <h4>{{ $t("price") }}</h4>
                  <div>
                    {{ item.price | currency }}
                  </div>
                </div>
              </template>

              <template v-if="item.courseWeeks && item.courseWeeks.length">
                <h3 class="my-5">{{ $t("CourseWeeks") }}</h3>

                <v-alert
                  v-if="
                    item.register_from_phase2 &&
                      item.register_to_phase2 &&
                      item.courseWeeks.find(i => i.full) &&
                      item.phase == 1
                  "
                  type="info"
                  dense
                  text
                >
                  {{
                    $t("registration_full_phase2_info", {
                      fromMinus1Day: $options.filters.formatDate(
                        moment(item.register_from_phase2)
                          .subtract(1, "days")
                          .format("YYYY-MM-DD")
                      ),
                      from: $options.filters.formatDate(
                        item.register_from_phase2
                      ),
                      to: $options.filters.formatDate(item.register_to_phase2),
                      toPhase1: $options.filters.formatDate(item.register_to)
                    })
                  }}
                </v-alert>

                <v-simple-table class="my-5" light>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">
                          {{ $t("name") }}
                        </th>
                        <th class="text-left">
                          {{ $t("period") }}
                        </th>
                        <th class="text-left">
                          {{ $t("price") }}
                        </th>
                        <th class="text-left">
                          {{ $t("program") }}
                        </th>
                        <th class="text-left">
                          {{ $t("state") }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, index) in item.courseWeeks"
                        :key="index"
                        :class="{ 'course-full': item.full }"
                      >
                        <td>
                          <span v-if="$i18n.locale == 'de'">{{
                            item.name
                          }}</span
                          ><span v-else>{{ item.name_it }}</span>
                        </td>
                        <td>
                          {{ item.from | formatDate }} |
                          {{ item.to | formatDate }}
                          <v-dialog
                            v-if="
                              ($i18n.locale == 'de' && item.time_info_de) ||
                                ($i18n.locale == 'it' && item.time_info_it)
                            "
                            transition="dialog-bottom-transition"
                            max-width="600"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn icon v-bind="attrs" v-on="on">
                                <v-icon dark>
                                  mdi-clock
                                </v-icon></v-btn
                              >
                            </template>
                            <template v-slot:default="dialog">
                              <v-card>
                                <v-toolbar :color="currentColor()" dark>{{
                                  $t("period")
                                }}</v-toolbar>
                                <v-card-text>
                                  <span
                                    v-if="$i18n.locale == 'de'"
                                    v-html="item.time_info_de"
                                  ></span>
                                  <span
                                    v-else
                                    v-html="item.time_info_it"
                                  ></span>
                                </v-card-text>
                                <v-card-actions class="justify-end">
                                  <v-btn text @click="dialog.value = false">{{
                                    $t("close")
                                  }}</v-btn>
                                </v-card-actions>
                              </v-card>
                            </template>
                          </v-dialog>
                        </td>
                        <td>
                          <template v-if="item.half_day">
                            {{ item.price_half_day | price }}
                          </template>
                          <span v-if="item.half_day && item.full_day"> | </span>
                          <template v-if="item.full_day">{{
                            item.price | currency
                          }}</template
                          ><span v-if="!item.half_day && !item.full_day"
                            >-</span
                          >
                        </td>
                        <td>
                          <template v-if="item.program">
                            <v-btn target="_blank" :href="item.program" icon
                              ><v-icon>mdi-download</v-icon></v-btn
                            > </template
                          ><span v-else>-</span>
                        </td>
                        <td>
                          <template v-if="item.full">{{
                            $t(`states.full`)
                          }}</template>
                          <template v-else>{{
                            $t(`states.${item.state}`)
                          }}</template>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </template>
            </v-card-text>

            <v-card-actions>
              <v-btn
                class="mr-4"
                @click="$router.push({ name: 'frontend.index' })"
              >
                {{ $t("back") }}
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                @click="book"
                :color="currentColor()"
                class="mr-4"
                :disabled="
                  /*!(
                    moment().diff(
                      item.register_from +
                        (item.register_from_time
                          ? ' ' + item.register_from_time
                          : '')
                    ) > 0 && moment().diff(moment(item.register_to).endOf('day')) <= 0
                  ) ||*/
                  item.courseWeeks.filter(
                    item => item.state == 'open' && !item.full
                  ).length == 0
                "
              >
                {{ $t("book") }}
              </v-btn>
            </v-card-actions>
          </template>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog
      v-model="signUpNewDialog"
      :max-width="500"
      @keydown.esc="signUpNewDialog = false"
    >
      <v-card>
        <v-card-title>
          <v-toolbar-title>{{
            $t("course_registration.register_or_login")
          }}</v-toolbar-title>
        </v-card-title>
        <v-card-text class="pa-4 mb-5">{{
          $t("course_registration.register_or_login_needed")
        }}</v-card-text>
        <v-card-actions class="pt-0">
          <v-btn
            color="primary darken-1"
            @click="$router.push({ name: 'auth.login' })"
            >{{ $t("Login") }}</v-btn
          >
          <v-btn
            color="primary darken-1"
            @click="$router.push({ name: 'auth.register' })"
            >{{ $t("register.button_submit") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-if="$auth.user().id && item"
      v-model="signUpDialog"
      scrollable
      persistent
      :overlay="false"
      max-width="900"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title>
          {{ $t("course_registration.title", { courseTitle: item.name }) }}
        </v-card-title>
        <v-card-text>
          <h3 class="mb-3">{{ $t("course_registration.subtitle") }}</h3>
          <p>{{ $t("course_registration.info") }}</p>
          <template v-if="$auth.user().people == null">
            <v-alert type="info">
              {{ $t("course_registration.warning_alert_no_people") }}
            </v-alert>
          </template>
          <template v-else-if="$auth.user().people.childrens.length == 0">
            <v-alert type="info">
              {{
                $t("course_registration.warning_alert_create_children_first")
              }}
            </v-alert>

            <v-btn
              color="secondary"
              class="mr-4"
              @click="$router.push({ name: 'frontend.my-family' })"
            >
              {{ $t("course_registration.add_children") }}
            </v-btn>
          </template>
          <template v-else>
            <v-row
              v-for="(bookedChildrenItem,
              bookedChildrenIndex) in bookedChildren"
              :key="`bookedChildrenIndex_${bookedChildrenIndex}`"
            >
              <v-col>
                <v-select
                  dense
                  solo
                  append-outer-icon="mdi-delete"
                  background-color="primary"
                  @click:append-outer="
                    bookedChildren.splice(bookedChildrenIndex, 1)
                  "
                  v-model="bookedChildrenItem.children"
                  :items="
                    children.filter(
                      filter =>
                        !bookedChildren
                          .map(i => (i.children ? i.children.id : 0))
                          .includes(filter.id) ||
                        filter.id ==
                          (bookedChildrenItem.children
                            ? bookedChildrenItem.children.id
                            : 0)
                    )
                  "
                  return-object
                  :label="$t('course_registration.select_children')"
                  item-text="display_name"
                  item-value="id"
                  hide-details
                ></v-select>
              </v-col>

              <v-col
                cols="12"
                v-if="
                  bookedChildrenItem.children &&
                    bookedChildrenItem.children.needs_update
                "
              >
                <v-alert
                  warning
                  class="ml-5 mr-5"
                  color="#dcdbdb"
                  dense
                  icon="mdi-alert-circle"
                >
                  <p>
                    {{
                      $t("course_registration.children_needs_update", {
                        name: bookedChildrenItem.children.display_name,
                        last_update: $options.filters.formatDate(
                          bookedChildrenItem.children.last_update
                        )
                      })
                    }}
                  </p>
                  <v-btn
                    @click="editChild(bookedChildrenItem.children)"
                    class="error mt-1"
                    small
                  >
                    {{ $t("course_registration.children_update_data") }}
                  </v-btn>
                </v-alert>
              </v-col>
              <v-col
                cols="12"
                v-if="
                  bookedChildrenItem.children &&
                    !bookedChildrenItem.children.needs_update
                "
              >
                <div class="ml-5 mr-5" v-if="item.custom_field">
                  <v-checkbox
                    v-if="item.custom_field_de.startsWith('#')"
                    v-model="custom_field[bookedChildrenIndex]"
                    data-vv-name="custom_field"
                    required
                    :error-messages="errors.collect('custom_field')"
                    :label="
                      $i18n.locale == 'de'
                        ? item.custom_field_de.slice(1) + ' *'
                        : item.custom_field_it.slice(1) + ' *'
                    "
                    value="CHECKED"
                    @change="handleCheckboxCustomFieldChange(bookedChildrenIndex)"
                  >
                </v-checkbox>
                  <v-text-field
                    v-else
                    outlined
                    color="secondary"
                    :label="item.custom_field_de + ' *'"
                    v-model="custom_field[bookedChildrenIndex]"
                    data-vv-name="custom_field"
                    required
                    :error-messages="errors.collect('custom_field')"
                  />
                </div>
                <div class="ml-5 mr-5" v-if="item.custom_field_2">
                  <v-checkbox
                    v-if="item.custom_field_2_de.startsWith('#')"
                    v-model="custom_field_2[bookedChildrenIndex]"
                    data-vv-name="custom_field"
                    required
                    :error-messages="errors.collect('custom_field')"
                    :label="
                      $i18n.locale == 'de'
                        ? item.custom_field_2_de.slice(1) + ' *'
                        : item.custom_field_2_it.slice(1) + ' *'
                    "
                    value="CHECKED"
                    @change="handleCheckboxCustomField2Change(bookedChildrenIndex)"
                  >
                </v-checkbox>
                  <v-text-field
                    v-else
                    outlined
                    color="secondary"
                    :label="item.custom_field_2_de + ' *'"
                    v-model="custom_field_2[bookedChildrenIndex]"
                    data-vv-name="custom_field_2"
                    required
                    :error-messages="errors.collect('custom_field_2')"
                  />
                </div>
              </v-col>
              <v-col
                class="mt-0 pt-0"
                cols="12"
                v-if="
                  bookedChildrenItem.children &&
                    !bookedChildrenItem.children.needs_update
                "
              >
                <v-simple-table class="ml-5" dense>
                  <thead>
                    <tr>
                      <th>{{ $t("week") }}</th>
                      <th
                        v-if="item.courseWeeks.filter(i => i.half_day).length"
                      >
                        {{
                          $i18n.locale == "de"
                            ? item.label_half_day_de
                            : item.label_half_day_it
                        }}
                      </th>
                      <th
                        v-if="item.courseWeeks.filter(i => i.full_day).length"
                      >
                        {{
                          $i18n.locale == "de"
                            ? item.label_full_day_de
                            : item.label_full_day_it
                        }}
                      </th>
                    </tr>
                  </thead>
                  <tbody class="no-hover">
                    <tr
                      v-for="courseWeekSetting in bookedChildrenItem.courseWeeks"
                      :key="`courseWeek_${courseWeekSetting.courseWeek.id}`"
                      :class="{
                        'week-disabled':
                          !courseWeekSetting.dayTypeFull &&
                          !courseWeekSetting.dayTypeHalf
                      }"
                    >
                      <td>
                        {{
                          courseWeekSetting.courseWeek[
                            `name${
                              $i18n.locale == "de" ? "" : "_" + $i18n.locale
                            }`
                          ]
                        }}
                      </td>
                      <td
                        v-if="item.courseWeeks.filter(i => i.half_day).length"
                      >
                        <v-checkbox
                          dense
                          hide-details
                          v-if="courseWeekSetting.courseWeek.half_day"
                          v-model="courseWeekSetting.dayTypeHalf"
                          @click="courseWeekSetting.dayTypeFull = false"
                        ></v-checkbox>
                      </td>
                      <td
                        v-if="item.courseWeeks.filter(i => i.full_day).length"
                      >
                        <v-checkbox
                          dense
                          hide-details
                          v-if="courseWeekSetting.courseWeek.full_day"
                          v-model="courseWeekSetting.dayTypeFull"
                          @click="courseWeekSetting.dayTypeHalf = false"
                        ></v-checkbox>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-col>
            </v-row>

            <v-row class="mb-3" v-if="$auth.user().people">
              <v-col>
                <v-btn
                  v-if="bookedChildren.length < children.length"
                  small
                  :color="currentColor()"
                  class="mt-1"
                  @click="addChild"
                >
                  <v-icon left>mdi-plus</v-icon>
                  {{ $t("course_registration.register_children") }}
                </v-btn>
                <v-alert
                  class="mt-2"
                  border="top"
                  colored-border
                  type="info"
                  elevation="2"
                  >{{ $t("course_registration.add_child_action_text") }}
                  <a
                    href="#"
                    @click.prevent="
                      $router.push({ name: 'frontend.my-family' })
                    "
                    >{{ $t("course_registration.add_child_action_button") }}</a
                  >
                </v-alert>
              </v-col>
            </v-row>

            <v-divider></v-divider>

            <h3 class="heading mt-2 mb-2">{{ $t("emergency_contacts") }}</h3>
            <v-row>
              <v-col cols="12" class="pb-0">
                <v-text-field
                  color="secondary"
                  :label="`${$t('emergency_contact')} 1*`"
                  name="emergency_contact1_phone"
                  prepend-icon="mdi-phone-alert"
                  v-model="emergency_contact1_phone"
                  data-vv-name="emergency_contact1_phone"
                  :error-messages="errors.collect('emergency_contact1_phone')"
                />
              </v-col>
              <v-col cols="12" class="pt-0">
                <v-text-field
                  color="secondary"
                  :label="`${$t('emergency_contact')} 2*`"
                  name="emergency_contact2_phone"
                  prepend-icon="mdi-phone-alert"
                  v-model="emergency_contact2_phone"
                  data-vv-name="emergency_contact2_phone"
                  :error-messages="errors.collect('emergency_contact2_phone')"
                />
              </v-col>
            </v-row>

            <v-divider></v-divider>

            <h3 class="heading mt-5 mb-3">{{ $t("Bemerkung") }}</h3>

            <v-textarea
              v-model="comment"
              filled
              :label="$t('Bemerkung')"
            ></v-textarea>

            <v-checkbox
              v-if="item.community_resident_required"
              required
              v-model="communityResident"
            >
              <template v-slot:label>
                <div>*{{ $t("community_resident") }}</div>
              </template>
            </v-checkbox>

            <v-checkbox v-if="item.house_rules" required v-model="houseRules">
              <template v-slot:label>
                <div>
                  *{{ $t("accept_house_rules") }} -
                  <a target="_blank" :href="item.house_rules" @click.stop>
                    {{ $t("Link") }}
                  </a>
                </div>
              </template>
            </v-checkbox>

            <v-checkbox required v-model="privacy">
              <template v-slot:label>
                <div>
                  *{{ $t("accept_privacy") }} -
                  <a target="_blank" :href="privacyLink()" @click.stop>
                    {{ $t("Link") }}
                  </a>
                </div>
              </template>
            </v-checkbox>
            <v-checkbox
              v-show="
                this.$store.state.modules.options.photo_privacy &&
                  this.$store.state.modules.options.photo_privacy == 1
              "
              required
              v-model="photo_privacy"
            >
              <template v-slot:label>
                <div>
                  {{ $t("photo_privacy") }} -
                  <a target="_blank" :href="privacyLink()" @click.stop>
                    {{ $t("Link") }}
                  </a>
                </div>
              </template>
            </v-checkbox>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-row>
            <v-col>
              <v-btn class="ma-1" color="secondary" @click="closeDialog">
                {{ $t("Cancel") }}
              </v-btn>
            </v-col>

            <v-col class="text-right">
              <v-btn
                class="ma-1"
                :color="currentColor()"
                @click="bookSave"
                :disabled="
                  !!(
                    !privacy ||
                    (!houseRules && item.house_rules) ||
                    (!communityResident && item.community_resident_required)
                  )
                "
                v-if="
                  $auth.user().people && $auth.user().people.childrens.length
                "
              >
                {{ $t("Anmeldung ausführen") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { saveItem, fetchItem, sendRegistration } from "../shared/services";
import Swal from "sweetalert2";
export default {
  name: "app-frontend-item",
  $_veeValidate: {
    validator: "new"
  },
  data() {
    return {
      item: null,
      signUpNewDialog: false,
      signUpDialog: false,
      permissions: [],
      bookedChildren: [],
      custom_field: [],
      custom_field_2: [],
      photo_privacy: null,
      comment: null,
      loading: true,
      privacy: false,
      houseRules: false,
      communityResident: false,
      emergency_contact2_phone: null,
      emergency_contact1_phone: null
    };
  },
  mounted() {
    Swal.close();
    if (this.$route.params.id) {
      this.loading = true;
      fetchItem(this.$route.params.id).then(res => {
        this.item = res.data;
        this.loading = false;
      });
      /*fetchMyFamily().then(res => {
        this.children = res.childrens;
        this.registrations = res.registrations;
        this.waitingQueue = res.waitingQueue;
        this.item = res.parent;
        this.loading = false;
      });*/
    } else {
      this.loading = false;
    }
  },
  computed: {
    computedFormValues() {
      return {
        ...this.formValues
      };
    },
    courseRegistrationWeekSelect() {
      return [
        ...this.item.courseWeeks.map(item => {
          return {
            label:
              item[
                `name${
                  this.$i18n.locale == "de" ? "" : "_" + this.$i18n.locale
                }`
              ],
            key: item.id
          };
        })
      ];
    },
    children() {
      return this.$auth.user().people ? this.$auth.user().people.childrens : [];
    }
  },
  methods: {
    addChild() {
      this.bookedChildren.push({
        children: null,
        courseWeeks: this.item.courseWeeks
          .filter(item => item.state == "open" && !item.full)
          .map(i => {
            let dayTypeFull = false;
            let dayTypeHalf = false;
            if (this.bookedChildren.length) {
              var last = this.bookedChildren[
                this.bookedChildren.length - 1
              ].courseWeeks.find(j => j.courseWeek.id == i.id);
              dayTypeFull = last.dayTypeFull;
              dayTypeHalf = last.dayTypeHalf;
            }

            return {
              courseWeek: i,
              dayTypeFull: dayTypeFull,
              dayTypeHalf: dayTypeHalf
            };
          })
      });

      this.addChildrenChildren = null;
    },

    editChild(item) {
      this.$router.push({
        name: "frontend.my-family",
        params: { childEditId: item.id, backUrl: window.location.pathname }
      });
    },

    closeDialog() {
      this.signUpDialog = false;
    },

    bookSave() {
      var errors = [];
      var lineNumber = 0;
      var duplicates = [];
      this.bookedChildren.forEach(item => {
        lineNumber++;
        if (
          !this.emergency_contact1_phone ||
          this.emergency_contact1_phone.length == 0
        ) {
          errors.push(this.$t("emergency_contact1_missing"));
        }

        if (
          !this.emergency_contact2_phone ||
          this.emergency_contact2_phone.length == 0
        ) {
          errors.push(this.$t("emergency_contact1_missing"));
        }

        if (
          this.item.custom_field &&
          (this.custom_field[lineNumber - 1] === undefined ||
            this.custom_field[lineNumber - 1].length == 0)
        ) {
          errors.push(
            this.$t("custom_field_required") +
              ": " +
              (this.$i18n.locale == "de"
                ? this.item.custom_field_de
                : this.item.custom_field_it) +
              " - " +
              item.children.first_name +
              " " +
              item.children.last_name
          );
        }

        if (
          this.item.custom_field_2 &&
          (this.custom_field_2[lineNumber - 1] === undefined ||
            this.custom_field_2[lineNumber - 1].length == 0)
        ) {
          errors.push(
            this.$t("custom_field_required") +
              ": " +
              (this.$i18n.locale == "de"
                ? this.item.custom_field_2_de
                : this.item.custom_field_2_it) +
              " - " +
              item.children.first_name +
              " " +
              item.children.last_name
          );
        }


        if (
          this.emergency_contact1_phone &&
          this.emergency_contact2_phone &&
          this.emergency_contact1_phone == this.emergency_contact2_phone
        ) {
          errors.push(this.$t("emergency_contacts_equal"));
        }

        if (!item.children) {
          errors.push(
            this.$t("course_registration.line") +
              " " +
              lineNumber +
              ": " +
              this.$t("course_registration.errors.please_add_child")
          );
        } else {
          item.courseWeeks.forEach(courseWeekConfig => {
            if (courseWeekConfig.courseWeek) {
              let duplicateKey =
                item.children.id + "_" + courseWeekConfig.courseWeek.id + "";
              if (duplicates.includes(duplicateKey)) {
                errors.push(
                  item.children.display_name +
                    ": " +
                    this.$t(
                      "course_registration.errors.duplicate_children_courseweek",
                      { courseWeek: courseWeekConfig.courseWeek.name }
                    )
                );
                return;
              }
              duplicates.push(duplicateKey);
            }
            if (!courseWeekConfig.courseWeek) {
              errors.push(
                item.children.display_name +
                  ": " +
                  this.$t("course_registration.errors.please_set_courseweek")
              );
            }
          });
        }
      });
      if (lineNumber == 0) {
        errors.push(this.$t("course_registration.errors.minimum_one_child"));
      }

      if (errors.length) {
        Swal.fire({
          title: this.$t("course_registration.alert_please_verify_errors"),
          html: errors.join("\n").replace("\n", "<br>"),
          icon: "error"
        });
        return;
      }

      Swal.fire({
        title: this.$t("really_send_title"),
        text: this.$t("really_send_registration_text"),
        preConfirm: () => {
          Swal.fire({
            title: this.$t("please_wait"),
            text: this.$t("sending_request_registration"),
            didOpen: async () => {
              Swal.showLoading();

              try {
                let resp = await sendRegistration(
                  this.item.id,
                  {
                    bookedChildren: this.bookedChildren.map(j => ({
                      ...j,
                      courseWeeks: j.courseWeeks
                        .filter(w => w.dayTypeFull || w.dayTypeHalf)
                        .map(k => ({
                          ...k,
                          dayType: k.dayTypeFull
                            ? "full_day"
                            : k.dayTypeHalf
                            ? "half_day"
                            : null
                        }))
                    })),
                    comment: this.comment,
                    emergency_contact1_phone: this.emergency_contact1_phone,
                    emergency_contact2_phone: this.emergency_contact2_phone,
                    photo_privacy: this.photo_privacy,
                    custom_field: this.custom_field,
                    custom_field_2: this.custom_field_2,
                    house_rules: this.houseRules,
                    community_resident: this.communityResident
                  },
                  this.$validator
                );
                Swal.close();
                this.$router.push({ name: "frontend.my-family" });
                Swal.fire({
                  icon: resp.waitingQueueWarnings ? "warning" : "success",
                  html: resp.message.join("<br>")
                });
                // setTimeout(() => {
                // this.$root.$notification(resp.message, { type: "success" });
                // }, 600)
              } catch (error) {
                if (error.response && error.response.status == 422) {
                  let errorBag = [];
                  for (let field in error.response.data.errors) {
                    errorBag.push(error.response.data.errors[field][0]);
                  }
                  Swal.fire({
                    title: this.$t("Fehler"),
                    html: errorBag.join("<br>"),
                    icon: "error"
                  });
                } else {
                  Swal.fire({
                    title: this.$t("Fehler"),
                    text: this.$t("generic_api_send_error"),
                    icon: "error"
                  });
                }
              }
            },
            showCancelButton: false,
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEnterClick: false,
            allowEscapeKey: false
          });
        },
        icon: "question",
        showCancelButton: true,
        showConfirmButton: true,
        cancelButtonText: this.$t("Cancel"),
        confirmButtonText: this.$t("Send"),
        confirmButtonColor: "green"
      });
    },

    book() {
      if (this.$auth.user().id) {
        this.signUpDialog = true;
        return;
      }
      this.signUpNewDialog = true;
      //      this.$router.push({ name: "auth.register" });
    },

    async saveItem() {
      this.$validator.reset();
      this.$validator.validateAll();
      let resp = await saveItem(
        this.$route.params.id,
        this.computedFormValues,
        this.$validator
      );
      if (resp.success) {
        this.$root.$notification(resp.message, { type: "success" });
        this.$router.push({ name: "frontend.index" });
      }
    },
    currentColor() {
      return this.$store.state.modules.options.app_color
        ? this.$store.state.modules.options.app_color
        : "primary";
    },
    privacyLink() {
      return this.$store.state.modules.options.app_privacy;
    },
    handleCheckboxCustomFieldChange(index) {
      if (!this.custom_field[index]) {
        // Completely remove the key from the object
        this.$delete(this.custom_field, index);
      }
    },
    handleCheckboxCustomField2Change(index) {
      if (!this.custom_field[index]) {
        // Completely remove the key from the object
        this.$delete(this.custom_field_2, index);
      }
    }

  }
};
</script>
<style>
/* .course-full {
  background-color: red;
  color: white;
} */
tr.week-disabled {
  opacity: 0.4;
  background: #d1d1d1;
}

tbody.no-hover {
  tr:hover {
    background-color: transparent !important;
  }
}
</style>
